import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

const SHOTS = [
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trading-metals-io/artifacts/mvne4e69_IMG_6685.webp",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trading-metals-io/artifacts/hwyp5jt6_IMG_6687.webp",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trading-metals-io/artifacts/k273mg0c_IMG_6689.webp",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_trading-metals-io/artifacts/40p8vp7p_IMG_6682.webp",
];

const OFFSETS = ["lg:translate-y-0", "lg:translate-y-10", "lg:translate-y-20", "lg:translate-y-10"];

const PhoneShot = ({ src, caption, index, testId }) => (
  <motion.figure
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay: index * 0.15, ease: EASE }}
    data-testid={testId}
    className={`group ${OFFSETS[index]}`}
  >
    <div className="relative">
      <div className="absolute -inset-3 bg-gradient-to-b from-[#C5A059]/15 to-[#E65100]/10 opacity-0 blur-2xl transition-opacity duration-700 group-hover:opacity-100" />
      <div className="relative rounded-[2.6rem] border border-[#2A2A2A] bg-[#050505] p-2 shadow-[0_30px_70px_rgba(0,0,0,0.6)] transition-colors duration-500 group-hover:border-[#C5A059]/50">
        <div className="relative overflow-hidden rounded-[2rem] border border-[#1F1F1F]">
          <img
            src={src}
            alt={caption.title}
            loading="lazy"
            className="aspect-[1170/2532] w-full bg-[#0A0A0A] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(197,160,89,0.18),transparent_60%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
        </div>
      </div>
    </div>
    <figcaption className="mt-8 flex items-start gap-4">
      <span className="font-cormorant text-4xl italic leading-none text-[#C5A059]/70">
        {String(index + 1).padStart(2, "0")}
      </span>
      <div>
        <p className="font-bebas text-2xl uppercase tracking-wide text-[#F5F5F5]">
          {caption.title}
        </p>
        <p className="mt-1 font-manrope text-sm leading-relaxed text-[#8A9199]">
          {caption.sub}
        </p>
      </div>
    </figcaption>
  </motion.figure>
);

export const Showcase = () => {
  const { lang, t } = useLanguage();

  return (
    <section
      data-testid="showcase-section"
      className="relative overflow-hidden bg-[#0A0A0A] py-28 md:py-40"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[500px] w-[900px] -translate-x-1/2 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.06),transparent_70%)] blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-24"
        >
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-12 bg-[#C5A059]" />
            <span className="font-manrope text-xs font-semibold uppercase tracking-[0.22em] text-[#C5A059]">
              {t.showcase.kicker}
            </span>
          </div>
          <h2 className="font-bebas text-4xl uppercase leading-none tracking-tight text-[#F5F5F5] sm:text-5xl lg:text-6xl">
            {t.showcase.heading}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 lg:pb-20">
          {t.showcase.captions.map((caption, i) => (
            <PhoneShot
              key={`${lang}-${i}`}
              src={SHOTS[i]}
              caption={caption}
              index={i}
              testId={`showcase-phone-${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
